import { numberFromString } from '../parsers'

/**
 * @function formatNumber
 * @param  {Number} number
 * @param  {String} locale
 * @return {String}
 *
 * @example
 * // returns "1 123 324 435" in local europe format
 * formatNumber(1123324435)
 */
export const formatNumberIntl = (number: number, locale?: string): string => {
  return new Intl.NumberFormat(locale).format(number)
}

/**
 * @function formatNumberWithDecimals
 * @param  {Number, String} value
 * @return {Number, String}
 *
 * @example
 * // returns "1000000" in local europe or american format
 * // formatNumberWithDecimals(1000000)
 * // returns 1,000,000 or 1.000.000
 */
export const formatNumberWithDecimals = (
  value: number | string,
  currency: 'eur' | 'usd',
): string | undefined => {
  const numberFormat: string = currency === 'eur' ? 'de-AT' : 'en-US'
  return numberFromString(String(value))?.toLocaleString(numberFormat)
}
